export function isUploadableFile(file: File): boolean {
  const relativePath = (file as File & { webkitRelativePath?: string }).webkitRelativePath?.trim() ?? "";
  if (relativePath.endsWith("/") || relativePath.endsWith("\\")) {
    return false;
  }
  const name = file.name.trim();
  if (name === "" || name.endsWith("/") || name.endsWith("\\")) {
    return false;
  }
  if (file.size === 0 && file.type.trim() === "") {
    return false;
  }
  return true;
}

export function fileMatchesAccept(file: { name: string; type: string }, accept: string | undefined): boolean {
  if (accept == null || accept.trim() === "") {
    return true;
  }
  const name = file.name.toLowerCase();
  const type = file.type.toLowerCase();
  return accept.split(",").some((raw) => {
    const token = raw.trim().toLowerCase();
    if (token === "") {
      return false;
    }
    if (token.startsWith(".")) {
      return name.endsWith(token);
    }
    if (token.endsWith("/*")) {
      return type.startsWith(token.slice(0, -1));
    }
    return type === token;
  });
}

export function filesFromDrop(
  files: ArrayLike<File>,
  options: { accept?: string; multiple?: boolean },
): File[] {
  const matched = Array.from(files).filter(
    (file) => isUploadableFile(file) && fileMatchesAccept(file, options.accept),
  );
  if (matched.length === 0) {
    return [];
  }
  if (options.multiple) {
    return matched;
  }
  return matched.slice(0, 1);
}
